// Polling intervals (ms) — API calls
export const POLL_ACTIVE_SESSION_MS = 2_000;       // active session status (live view, upload sessions, details)
export const POLL_LIVE_VIEW_DATA_MS = 2_000;       // live view gauge data poll (also updates LastRequestedDate)
export const POLL_DATA_FILES_MS = 10_000;          // data files grid refresh
export const POLL_HEARTBEAT_LIST_MS = 10_000;      // heartbeat list grid refresh
export const POLL_LIVE_DETECTION_MS = 5_000;       // dashboard recent files grid, liveview page, ClientDetailsPage

// UI-only tick intervals (ms)
export const TICK_FRESHNESS_MS = 1_000;            // freshness "seconds ago" counter
export const TICK_SESSION_DURATION_MS = 1_000;     // session elapsed timer
export const DEVICE_ONLINE_dURATION_MS = 45_000       // LastUpdate on heartbeat > 45 seconds its offline 

// Thresholds (ms)
export const STALE_THRESHOLD_MS = 60_000;               // data considered stale after 60s
export const LIVE_WRITE_THRESHOLD_MS = 5 * 60 * 1000;   // File considered LIVE mode 
export const ONLINE_THRESHOLD_MS = 45_000;              // When a device is consider offline from lastUpdated on heartbeat 
